export default "__VITE_ASSET__08809cda__"